import PlayersContainer from "../components/players/PlayersContainer";

const Players = () => (
    <>
      <h1 className="display-5">The Team</h1>
      <PlayersContainer />
    </>
);

export default Players;